import { FC } from 'react';
import { Cascader } from 'antd';
import { CascaderValueType } from 'antd/lib/cascader';

const LangSelect: FC<CustomFieldsProps> = (props) => {
  const { value, onChange } = props;

  let _value = (value || 'en,US').split(',');
  _value[1] = `${_value[0]}_${_value[1]}`;

  const handleChange = (v: CascaderValueType) => {
    let _v = v.slice();
    _v[1] = (_v[1] as string).match(/_([^_]+)$/)![1];
    onChange && onChange(_v.join(','));
  };

  return (
    <Cascader
      value={_value}
      options={langOptions}
      allowClear={false}
      onChange={(v) => {
        handleChange(v);
      }}
    />
  );
};

export default LangSelect;

const langOptions = [
  {
    value: 'dje',
    label: 'Zarmaciine',
    children: [
      {
        value: 'dje_NE',
        label: 'Nižer',
      },
    ],
  },
  {
    value: 'lu',
    label: 'Tshiluba',
    children: [
      {
        value: 'lu_CD',
        label: 'Ditunga wa Kongu',
      },
    ],
  },
  {
    value: 'ks',
    label: 'کٲشُر',
    children: [
      {
        value: 'ks_IN',
        label: 'ہِنٛدوستان',
      },
    ],
  },
  {
    value: 'fy',
    label: 'West-Frysk',
    children: [
      {
        value: 'fy_NL',
        label: 'Nederlân',
      },
    ],
  },
  {
    value: 'fo',
    label: 'Føroyskt',
    children: [
      {
        value: 'fo_DK',
        label: 'Danmark',
      },
      {
        value: 'fo_FO',
        label: 'Føroyar',
      },
    ],
  },
  {
    value: 'sd',
    label: 'سِندی',
    children: [
      {
        value: 'sd_IN',
        label: 'ہِنٛدوستان',
      },
    ],
  },
  {
    value: 'tzm',
    label: 'Tamaziɣt n laṭlaṣ',
    children: [
      {
        value: 'tzm_MA',
        label: 'Meṛṛuk',
      },
    ],
  },
  {
    value: 'dav',
    label: 'Kitaita',
    children: [
      {
        value: 'dav_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'zgh',
    label: 'ⵜⴰⵎⴰⵣⵉⵖⵜ',
    children: [
      {
        value: 'zgh_MA',
        label: 'ⵍⵎⵖⵔⵉⴱ',
      },
    ],
  },
  {
    value: 'kw',
    label: 'Kernewek',
    children: [
      {
        value: 'kw_GB',
        label: 'Rywvaneth Unys',
      },
    ],
  },
  {
    value: 'rof',
    label: 'Kihorombo',
    children: [
      {
        value: 'rof_TZ',
        label: 'Tanzania',
      },
    ],
  },
  {
    value: 'chr',
    label: 'ᏣᎳᎩ',
    children: [
      {
        value: 'chr_US',
        label: 'ᎠᎹᏰᏟ',
      },
    ],
  },
  {
    value: 'ti',
    label: 'ትግርኛ',
    children: [
      {
        value: 'ti_ET',
        label: 'ET',
      },
      {
        value: 'ti_ER',
        label: 'ER',
      },
    ],
  },
  {
    value: 'fi',
    label: 'Suomi',
    children: [
      {
        value: 'fi_FI',
        label: 'Suomi',
      },
    ],
  },
  {
    value: 'eu',
    label: 'Euskara',
    children: [
      {
        value: 'eu_ES',
        label: 'Espainia',
      },
    ],
  },
  {
    value: 'yav',
    label: 'Nuasue',
    children: [
      {
        value: 'yav_CM',
        label: 'Kemelún',
      },
    ],
  },
  {
    value: 'gl',
    label: 'Galego',
    children: [
      {
        value: 'gl_ES',
        label: 'España',
      },
    ],
  },
  {
    value: 'jgo',
    label: 'Ndaꞌa',
    children: [
      {
        value: 'jgo_CM',
        label: 'Kamɛlûn',
      },
    ],
  },
  {
    value: 'ksh',
    label: 'Kölsch',
    children: [
      {
        value: 'ksh_DE',
        label: 'Doütschland',
      },
    ],
  },
  {
    value: 'sq',
    label: 'Shqip',
    children: [
      {
        value: 'sq_XK',
        label: 'Kosovë',
      },
      {
        value: 'sq_AL',
        label: 'Shqipëri',
      },
      {
        value: 'sq_MK',
        label: 'Maqedoni',
      },
    ],
  },
  {
    value: 'kn',
    label: 'ಕನ್ನಡ',
    children: [
      {
        value: 'kn_IN',
        label: 'ಭಾರತ',
      },
    ],
  },
  {
    value: 'is',
    label: 'Íslenska',
    children: [
      {
        value: 'is_IS',
        label: 'Ísland',
      },
    ],
  },
  {
    value: 'nnh',
    label: 'Shwóŋò ngiembɔɔn',
    children: [
      {
        value: 'nnh_CM',
        label: 'Kàmalûm',
      },
    ],
  },
  {
    value: 'ig',
    label: 'Igbo',
    children: [
      {
        value: 'ig_NG',
        label: 'Nigeria',
      },
    ],
  },
  {
    value: 'sg',
    label: 'Sängö',
    children: [
      {
        value: 'sg_CF',
        label: 'Ködörösêse tî Bêafrîka',
      },
    ],
  },
  {
    value: 'my',
    label: 'ဗမာ',
    children: [
      {
        value: 'my_MM',
        label: 'မြန်မာ',
      },
    ],
  },
  {
    value: 'wae',
    label: 'Walser',
    children: [
      {
        value: 'wae_CH',
        label: 'Schwiz',
      },
    ],
  },
  {
    value: 'haw',
    label: 'ʻŌlelo Hawaiʻi',
    children: [
      {
        value: 'haw_US',
        label: 'ʻAmelika Hui Pū ʻIa',
      },
    ],
  },
  {
    value: 'so',
    label: 'Soomaali',
    children: [
      {
        value: 'so_DJ',
        label: 'Jabuuti',
      },
      {
        value: 'so_SO',
        label: 'Soomaaliya',
      },
      {
        value: 'so_ET',
        label: 'Itoobiya',
      },
      {
        value: 'so_KE',
        label: 'Kiiniya',
      },
    ],
  },
  {
    value: 'pa_Guru',
    label: 'ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ)',
    children: [
      {
        value: 'pa_Guru_IN',
        label: 'ਭਾਰਤ',
      },
    ],
  },
  {
    value: 'saq',
    label: 'Kisampur',
    children: [
      {
        value: 'saq_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'smn',
    label: 'Anarâškielâ',
    children: [
      {
        value: 'smn_FI',
        label: 'Suomâ',
      },
    ],
  },
  {
    value: 'sr_Cyrl',
    label: 'Српски (ћирилица)',
    children: [
      {
        value: 'sr_Cyrl_XK',
        label: 'Косово',
      },
      {
        value: 'sr_Cyrl_BA',
        label: 'Босна и Херцеговина',
      },
      {
        value: 'sr_Cyrl_ME',
        label: 'Црна Гора',
      },
      {
        value: 'sr_Cyrl_RS',
        label: 'Србија',
      },
    ],
  },
  {
    value: 'luy',
    label: 'Luluhia',
    children: [
      {
        value: 'luy_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'ki',
    label: 'Gikuyu',
    children: [
      {
        value: 'ki_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'gu',
    label: 'ગુજરાતી',
    children: [
      {
        value: 'gu_IN',
        label: 'ભારત',
      },
    ],
  },
  {
    value: 'az_Latn',
    label: 'Azərbaycan dili (latın)',
    children: [
      {
        value: 'az_Latn_AZ',
        label: 'Azərbaycan',
      },
    ],
  },
  {
    value: 'ce',
    label: 'Нохчийн',
    children: [
      {
        value: 'ce_RU',
        label: 'Росси',
      },
    ],
  },
  {
    value: 'fa',
    label: 'فارسی',
    children: [
      {
        value: 'fa_AF',
        label: 'افغانستان',
      },
      {
        value: 'fa_IR',
        label: 'ایران',
      },
    ],
  },
  {
    value: 'yo',
    label: 'Èdè Yorùbá',
    children: [
      {
        value: 'yo_NG',
        label: 'Orílẹ́ède Nàìjíríà',
      },
      {
        value: 'yo_BJ',
        label: 'Orílɛ́ède Bɛ̀nɛ̀',
      },
    ],
  },
  {
    value: 'kln',
    label: 'Kalenjin',
    children: [
      {
        value: 'kln_KE',
        label: 'Emetab Kenya',
      },
    ],
  },
  {
    value: 'twq',
    label: 'Tasawaq senni',
    children: [
      {
        value: 'twq_NE',
        label: 'Nižer',
      },
    ],
  },
  {
    value: 'uz_Arab',
    label: 'اوزبیک (عربی)',
    children: [
      {
        value: 'uz_Arab_AF',
        label: 'افغانستان',
      },
    ],
  },
  {
    value: 'fur',
    label: 'Furlan',
    children: [
      {
        value: 'fur_IT',
        label: 'Italie',
      },
    ],
  },
  {
    value: 'bem',
    label: 'Ichibemba',
    children: [
      {
        value: 'bem_ZM',
        label: 'Zambia',
      },
    ],
  },
  {
    value: 'ses',
    label: 'Koyraboro senni',
    children: [
      {
        value: 'ses_ML',
        label: 'Maali',
      },
    ],
  },
  {
    value: 'ebu',
    label: 'Kĩembu',
    children: [
      {
        value: 'ebu_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'ko',
    label: '한국어',
    children: [
      {
        value: 'ko_KP',
        label: '조선민주주의인민공화국',
      },
      {
        value: 'ko_KR',
        label: '대한민국',
      },
    ],
  },
  {
    value: 'mn',
    label: 'Монгол',
    children: [
      {
        value: 'mn_MN',
        label: 'Монгол',
      },
    ],
  },
  {
    value: 'sw',
    label: 'Kiswahili',
    children: [
      {
        value: 'sw_CD',
        label: 'Jamhuri ya Kidemokrasia ya Kongo',
      },
      {
        value: 'sw_TZ',
        label: 'Tanzania',
      },
      {
        value: 'sw_KE',
        label: 'Kenya',
      },
      {
        value: 'sw_UG',
        label: 'Uganda',
      },
    ],
  },
  {
    value: 'rw',
    label: 'Kinyarwanda',
    children: [
      {
        value: 'rw_RW',
        label: 'Rwanda',
      },
    ],
  },
  {
    value: 'bg',
    label: 'Български',
    children: [
      {
        value: 'bg_BG',
        label: 'България',
      },
    ],
  },
  {
    value: 'jmc',
    label: 'Kimachame',
    children: [
      {
        value: 'jmc_TZ',
        label: 'Tanzania',
      },
    ],
  },
  {
    value: 'mfe',
    label: 'Kreol morisien',
    children: [
      {
        value: 'mfe_MU',
        label: 'Moris',
      },
    ],
  },
  {
    value: 'zh_Hans',
    label: '简体中文',
    children: [
      {
        value: 'zh_Hans_MO',
        label: '澳门',
      },
      {
        value: 'zh_Hans_CN',
        label: '中国',
      },
      {
        value: 'zh_Hans_HK',
        label: '香港',
      },
      {
        value: 'zh_Hans_SG',
        label: '新加坡',
      },
    ],
  },
  {
    value: 'ca',
    label: 'Català',
    children: [
      {
        value: 'ca_ES',
        label: 'Espanya',
      },
      {
        value: 'ca_AD',
        label: 'Andorra',
      },
      {
        value: 'ca_IT',
        label: 'Itàlia',
      },
      {
        value: 'ca_FR',
        label: 'França',
      },
    ],
  },
  {
    value: 'az_Cyrl',
    label: 'Азәрбајҹан дили (Кирил)',
    children: [
      {
        value: 'az_Cyrl_AZ',
        label: 'Азәрбајҹан',
      },
    ],
  },
  {
    value: 'sbp',
    label: 'Ishisangu',
    children: [
      {
        value: 'sbp_TZ',
        label: 'Tansaniya',
      },
    ],
  },
  {
    value: 'doi',
    label: 'डोग्री',
    children: [
      {
        value: 'doi_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'zh_Hant',
    label: '繁體中文',
    children: [
      {
        value: 'zh_Hant_HK',
        label: '香港',
      },
      {
        value: 'zh_Hant_MO',
        label: '澳門',
      },
      {
        value: 'zh_Hant_TW',
        label: '台灣',
      },
    ],
  },
  {
    value: 'sat',
    label: 'ᱥᱟᱱᱛᱟᱞᱤ',
    children: [
      {
        value: 'sat_IN',
        label: 'India',
      },
    ],
  },
  {
    value: 'sah',
    label: 'Саха тыла',
    children: [
      {
        value: 'sah_RU',
        label: 'Арассыыйа',
      },
    ],
  },
  {
    value: 'ta',
    label: 'தமிழ்',
    children: [
      {
        value: 'ta_SG',
        label: 'சிங்கப்பூர்',
      },
      {
        value: 'ta_LK',
        label: 'இலங்கை',
      },
      {
        value: 'ta_MY',
        label: 'மலேசியா',
      },
      {
        value: 'ta_IN',
        label: 'இந்தியா',
      },
    ],
  },
  {
    value: 'ewo',
    label: 'Ewondo',
    children: [
      {
        value: 'ewo_CM',
        label: 'Kamərún',
      },
    ],
  },
  {
    value: 'sl',
    label: 'Slovenščina',
    children: [
      {
        value: 'sl_SI',
        label: 'Slovenija',
      },
    ],
  },
  {
    value: 'pa_Arab',
    label: 'پنجابی (عربی)',
    children: [
      {
        value: 'pa_Arab_PK',
        label: 'پکستان',
      },
    ],
  },
  {
    value: 'kl',
    label: 'Kalaallisut',
    children: [
      {
        value: 'kl_GL',
        label: 'Kalaallit Nunaat',
      },
    ],
  },
  {
    value: 'ha',
    label: 'Hausa',
    children: [
      {
        value: 'ha_NE',
        label: 'Nijar',
      },
      {
        value: 'ha_NG',
        label: 'Najeriya',
      },
      {
        value: 'ha_GH',
        label: 'Gana',
      },
    ],
  },
  {
    value: 'mg',
    label: 'Malagasy',
    children: [
      {
        value: 'mg_MG',
        label: 'Madagasikara',
      },
    ],
  },
  {
    value: 'se',
    label: 'Davvisámegiella',
    children: [
      {
        value: 'se_SE',
        label: 'Ruoŧŧa',
      },
      {
        value: 'se_NO',
        label: 'Norga',
      },
      {
        value: 'se_FI',
        label: 'Suopma',
      },
    ],
  },
  {
    value: 'khq',
    label: 'Koyra ciini',
    children: [
      {
        value: 'khq_ML',
        label: 'Maali',
      },
    ],
  },
  {
    value: 'mzn',
    label: 'مازرونی',
    children: [
      {
        value: 'mzn_IR',
        label: 'ایران',
      },
    ],
  },
  {
    value: 'ms',
    label: 'Bahasa Melayu',
    children: [
      {
        value: 'ms_BN',
        label: 'Brunei',
      },
      {
        value: 'ms_MY',
        label: 'Malaysia',
      },
      {
        value: 'ms_SG',
        label: 'Singapura',
      },
    ],
  },
  {
    value: 'lkt',
    label: 'Lakȟólʼiyapi',
    children: [
      {
        value: 'lkt_US',
        label: 'Mílahaŋska Tȟamákȟočhe',
      },
    ],
  },
  {
    value: 'ug',
    label: 'ئۇيغۇرچە',
    children: [
      {
        value: 'ug_CN',
        label: 'جۇڭگو',
      },
    ],
  },
  {
    value: 'qu',
    label: 'Runasimi',
    children: [
      {
        value: 'qu_BO',
        label: 'Bolivia',
      },
      {
        value: 'qu_EC',
        label: 'Ecuador',
      },
      {
        value: 'qu_PE',
        label: 'Perú',
      },
    ],
  },
  {
    value: 'kk',
    label: 'Қазақ тілі',
    children: [
      {
        value: 'kk_KZ',
        label: 'Қазақстан',
      },
    ],
  },
  {
    value: 'rn',
    label: 'Ikirundi',
    children: [
      {
        value: 'rn_BI',
        label: 'Uburundi',
      },
    ],
  },
  {
    value: 'kea',
    label: 'Kabuverdianu',
    children: [
      {
        value: 'kea_CV',
        label: 'Kabu Verdi',
      },
    ],
  },
  {
    value: 'kok',
    label: 'कोंकणी',
    children: [
      {
        value: 'kok_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'am',
    label: 'አማርኛ',
    children: [
      {
        value: 'am_ET',
        label: 'ኢትዮጵያ',
      },
    ],
  },
  {
    value: 'sk',
    label: 'Slovenčina',
    children: [
      {
        value: 'sk_SK',
        label: 'Slovensko',
      },
    ],
  },
  {
    value: 'ar',
    label: 'العربية',
    children: [
      {
        value: 'ar_OM',
        label: 'عُمان',
      },
      {
        value: 'ar_ER',
        label: 'إريتريا',
      },
      {
        value: 'ar_SA',
        label: 'المملكة العربية السعودية',
      },
      {
        value: 'ar_YE',
        label: 'اليمن',
      },
      {
        value: 'ar_MR',
        label: 'موريتانيا',
      },
      {
        value: 'ar_PS',
        label: 'فلسطين',
      },
      {
        value: 'ar_QA',
        label: 'قطر',
      },
      {
        value: 'ar_JO',
        label: 'الأردن',
      },
      {
        value: 'ar_SS',
        label: 'جنوب السودان',
      },
      {
        value: 'ar_LY',
        label: 'ليبيا',
      },
      {
        value: 'ar_SD',
        label: 'السودان',
      },
      {
        value: 'ar_KM',
        label: 'جزر القمر',
      },
      {
        value: 'ar_SO',
        label: 'الصومال',
      },
      {
        value: 'ar_LB',
        label: 'لبنان',
      },
      {
        value: 'ar_AE',
        label: 'الإمارات العربية المتحدة',
      },
      {
        value: 'ar_IQ',
        label: 'العراق',
      },
      {
        value: 'ar_DJ',
        label: 'جيبوتي',
      },
      {
        value: 'ar_BH',
        label: 'البحرين',
      },
      {
        value: 'ar_MA',
        label: 'المغرب',
      },
      {
        value: 'ar_TD',
        label: 'تشاد',
      },
      {
        value: 'ar_KW',
        label: 'الكويت',
      },
      {
        value: 'ar_DZ',
        label: 'الجزائر',
      },
      {
        value: 'ar_EH',
        label: 'الصحراء الغربية',
      },
      {
        value: 'ar_EG',
        label: 'مصر',
      },
      {
        value: 'ar_TN',
        label: 'تونس',
      },
      {
        value: 'ar_SY',
        label: 'سوريا',
      },
      {
        value: 'ar_IL',
        label: 'إسرائيل',
      },
    ],
  },
  {
    value: 'om',
    label: 'Oromoo',
    children: [
      {
        value: 'om_ET',
        label: 'Itoophiyaa',
      },
      {
        value: 'om_KE',
        label: 'Keeniyaa',
      },
    ],
  },
  {
    value: 'ksf',
    label: 'Rikpa',
    children: [
      {
        value: 'ksf_CM',
        label: 'kamɛrún',
      },
    ],
  },
  {
    value: 'nus',
    label: 'Thok Nath',
    children: [
      {
        value: 'nus_SS',
        label: 'SS',
      },
    ],
  },
  {
    value: 'ee',
    label: 'Eʋegbe',
    children: [
      {
        value: 'ee_TG',
        label: 'Togo nutome',
      },
      {
        value: 'ee_GH',
        label: 'Ghana nutome',
      },
    ],
  },
  {
    value: 'sr_Latn',
    label: 'Srpski (latinica)',
    children: [
      {
        value: 'sr_Latn_ME',
        label: 'Crna Gora',
      },
      {
        value: 'sr_Latn_XK',
        label: 'Kosovo',
      },
      {
        value: 'sr_Latn_BA',
        label: 'Bosna i Hercegovina',
      },
      {
        value: 'sr_Latn_RS',
        label: 'Srbija',
      },
    ],
  },
  {
    value: 'asa',
    label: 'Kipare',
    children: [
      {
        value: 'asa_TZ',
        label: 'Tadhania',
      },
    ],
  },
  {
    value: 'rm',
    label: 'Rumantsch',
    children: [
      {
        value: 'rm_CH',
        label: 'Svizra',
      },
    ],
  },
  {
    value: 'hy',
    label: 'Հայերեն',
    children: [
      {
        value: 'hy_AM',
        label: 'Հայաստան',
      },
    ],
  },
  {
    value: 'ff',
    label: 'Pulaar',
    children: [
      {
        value: 'ff_CM',
        label: 'Kameruun',
      },
      {
        value: 'ff_GN',
        label: 'Gine',
      },
      {
        value: 'ff_SN',
        label: 'Senegaal',
      },
      {
        value: 'ff_MR',
        label: 'Muritani',
      },
    ],
  },
  {
    value: 'kde',
    label: 'Chimakonde',
    children: [
      {
        value: 'kde_TZ',
        label: 'Tanzania',
      },
    ],
  },
  {
    value: 'to',
    label: 'Lea fakatonga',
    children: [
      {
        value: 'to_TO',
        label: 'Tonga',
      },
    ],
  },
  {
    value: 'es',
    label: 'Español',
    children: [
      {
        value: 'es_UY',
        label: 'Uruguay',
      },
      {
        value: 'es_PR',
        label: 'Puerto Rico',
      },
      {
        value: 'es_DO',
        label: 'República Dominicana',
      },
      {
        value: 'es_AR',
        label: 'Argentina',
      },
      {
        value: 'es_CO',
        label: 'Colombia',
      },
      {
        value: 'es_CL',
        label: 'Chile',
      },
      {
        value: 'es_GT',
        label: 'Guatemala',
      },
      {
        value: 'es_IC',
        label: 'Canarias',
      },
      {
        value: 'es_SV',
        label: 'El Salvador',
      },
      {
        value: 'es_HN',
        label: 'Honduras',
      },
      {
        value: 'es_PA',
        label: 'Panamá',
      },
      {
        value: 'es_MX',
        label: 'México',
      },
      {
        value: 'es_NI',
        label: 'Nicaragua',
      },
      {
        value: 'es_GQ',
        label: 'Guinea Ecuatorial',
      },
      {
        value: 'es_VE',
        label: 'Venezuela',
      },
      {
        value: 'es_ES',
        label: 'España',
      },
      {
        value: 'es_EC',
        label: 'Ecuador',
      },
      {
        value: 'es_EA',
        label: 'Ceuta y Melilla',
      },
      {
        value: 'es_CU',
        label: 'Cuba',
      },
      {
        value: 'es_PY',
        label: 'Paraguay',
      },
      {
        value: 'es_PH',
        label: 'Filipinas',
      },
      {
        value: 'es_CR',
        label: 'Costa Rica',
      },
      {
        value: 'es_US',
        label: 'Estados Unidos',
      },
      {
        value: 'es_BO',
        label: 'Bolivia',
      },
      {
        value: 'es_PE',
        label: 'Perú',
      },
    ],
  },
  {
    value: 'fil',
    label: 'Filipino',
    children: [
      {
        value: 'fil_PH',
        label: 'Pilipinas',
      },
    ],
  },
  {
    value: 'mer',
    label: 'Kĩmĩrũ',
    children: [
      {
        value: 'mer_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'ur',
    label: 'اردو',
    children: [
      {
        value: 'ur_PK',
        label: 'پاکستان',
      },
      {
        value: 'ur_IN',
        label: 'بھارت',
      },
    ],
  },
  {
    value: 'be',
    label: 'Беларуская',
    children: [
      {
        value: 'be_BY',
        label: 'Беларусь',
      },
    ],
  },
  {
    value: 'sn',
    label: 'ChiShona',
    children: [
      {
        value: 'sn_ZW',
        label: 'Zimbabwe',
      },
    ],
  },
  {
    value: 'uk',
    label: 'Українська',
    children: [
      {
        value: 'uk_UA',
        label: 'Україна',
      },
    ],
  },
  {
    value: 'os',
    label: 'Ирон',
    children: [
      {
        value: 'os_RU',
        label: 'Уӕрӕсе',
      },
      {
        value: 'os_GE',
        label: 'Гуырдзыстон',
      },
    ],
  },
  {
    value: 'pl',
    label: 'Polski',
    children: [
      {
        value: 'pl_PL',
        label: 'Polska',
      },
    ],
  },
  {
    value: 'zu',
    label: 'IsiZulu',
    children: [
      {
        value: 'zu_ZA',
        label: 'i-South Africa',
      },
    ],
  },
  {
    value: 'cy',
    label: 'Cymraeg',
    children: [
      {
        value: 'cy_GB',
        label: 'Y Deyrnas Unedig',
      },
    ],
  },
  {
    value: 'vun',
    label: 'Kyivunjo',
    children: [
      {
        value: 'vun_TZ',
        label: 'Tanzania',
      },
    ],
  },
  {
    value: 'cgg',
    label: 'Rukiga',
    children: [
      {
        value: 'cgg_UG',
        label: 'Uganda',
      },
    ],
  },
  {
    value: 'bez',
    label: 'Hibena',
    children: [
      {
        value: 'bez_TZ',
        label: 'Hutanzania',
      },
    ],
  },
  {
    value: 'ky',
    label: 'Кыргызча',
    children: [
      {
        value: 'ky_KG',
        label: 'Кыргызстан',
      },
    ],
  },
  {
    value: 'mgo',
    label: 'Metaʼ',
    children: [
      {
        value: 'mgo_CM',
        label: 'Kamalun',
      },
    ],
  },
  {
    value: 'gsw',
    label: 'Schwiizertüütsch',
    children: [
      {
        value: 'gsw_LI',
        label: 'Liächteschtäi',
      },
      {
        value: 'gsw_CH',
        label: 'Schwiiz',
      },
      {
        value: 'gsw_FR',
        label: 'Frankriich',
      },
    ],
  },
  {
    value: 'ii',
    label: 'ꆈꌠꉙ',
    children: [
      {
        value: 'ii_CN',
        label: 'ꍏꇩ',
      },
    ],
  },
  {
    value: 'mr',
    label: 'मराठी',
    children: [
      {
        value: 'mr_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'bo',
    label: 'བོད་སྐད་',
    children: [
      {
        value: 'bo_IN',
        label: 'རྒྱ་གར་',
      },
      {
        value: 'bo_CN',
        label: 'རྒྱ་ནག',
      },
    ],
  },
  {
    value: 'mni',
    label: 'মণিপুরী',
    children: [
      {
        value: 'mni_IN',
        label: 'ভারত',
      },
    ],
  },
  {
    value: 'gd',
    label: 'Gàidhlig',
    children: [
      {
        value: 'gd_GB',
        label: 'An Rìoghachd Aonaichte',
      },
    ],
  },
  {
    value: 'lv',
    label: 'Latviešu',
    children: [
      {
        value: 'lv_LV',
        label: 'Latvija',
      },
    ],
  },
  {
    value: 'tr',
    label: 'Türkçe',
    children: [
      {
        value: 'tr_CY',
        label: 'Güney Kıbrıs Rum Kesimi',
      },
      {
        value: 'tr_TR',
        label: 'Türkiye',
      },
    ],
  },
  {
    value: 'ja',
    label: '日本語',
    children: [
      {
        value: 'ja_JP',
        label: '日本',
      },
    ],
  },
  {
    value: 'el',
    label: 'Ελληνικά',
    children: [
      {
        value: 'el_CY',
        label: 'Κύπρος',
      },
      {
        value: 'el_GR',
        label: 'Ελλάδα',
      },
    ],
  },
  {
    value: 'guz',
    label: 'Ekegusii',
    children: [
      {
        value: 'guz_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'ln',
    label: 'Lingála',
    children: [
      {
        value: 'ln_CG',
        label: 'Kongo',
      },
      {
        value: 'ln_CF',
        label: 'Repibiki ya Afríka ya Káti',
      },
      {
        value: 'ln_CD',
        label: 'Repibiki demokratiki ya Kongó',
      },
      {
        value: 'ln_AO',
        label: 'Angóla',
      },
    ],
  },
  {
    value: 'xog',
    label: 'Olusoga',
    children: [
      {
        value: 'xog_UG',
        label: 'Yuganda',
      },
    ],
  },
  {
    value: 'ne',
    label: 'नेपाली',
    children: [
      {
        value: 'ne_IN',
        label: 'भारत',
      },
      {
        value: 'ne_NP',
        label: 'नेपाल',
      },
    ],
  },
  {
    value: 'sv',
    label: 'Svenska',
    children: [
      {
        value: 'sv_SE',
        label: 'Sverige',
      },
      {
        value: 'sv_FI',
        label: 'Finland',
      },
      {
        value: 'sv_AX',
        label: 'Åland',
      },
    ],
  },
  {
    value: 'dsb',
    label: 'Dolnoserbšćina',
    children: [
      {
        value: 'dsb_DE',
        label: 'Nimska',
      },
    ],
  },
  {
    value: 'lo',
    label: 'ລາວ',
    children: [
      {
        value: 'lo_LA',
        label: 'ລາວ',
      },
    ],
  },
  {
    value: 'nn',
    label: 'Nynorsk',
    children: [
      {
        value: 'nn_NO',
        label: 'Noreg',
      },
    ],
  },
  {
    value: 'fr',
    label: 'Français',
    children: [
      {
        value: 'fr_PM',
        label: 'Saint-Pierre-et-Miquelon',
      },
      {
        value: 'fr_TG',
        label: 'Togo',
      },
      {
        value: 'fr_SY',
        label: 'Syrie',
      },
      {
        value: 'fr_CI',
        label: 'Côte d’Ivoire',
      },
      {
        value: 'fr_PF',
        label: 'Polynésie française',
      },
      {
        value: 'fr_ML',
        label: 'Mali',
      },
      {
        value: 'fr_CD',
        label: 'Congo-Kinshasa',
      },
      {
        value: 'fr_MC',
        label: 'Monaco',
      },
      {
        value: 'fr_TD',
        label: 'Tchad',
      },
      {
        value: 'fr_SC',
        label: 'Seychelles',
      },
      {
        value: 'fr_SN',
        label: 'Sénégal',
      },
      {
        value: 'fr_MG',
        label: 'Madagascar',
      },
      {
        value: 'fr_TN',
        label: 'Tunisie',
      },
      {
        value: 'fr_WF',
        label: 'Wallis-et-Futuna',
      },
      {
        value: 'fr_BE',
        label: 'Belgique',
      },
      {
        value: 'fr_BF',
        label: 'Burkina Faso',
      },
      {
        value: 'fr_CM',
        label: 'Cameroun',
      },
      {
        value: 'fr_CF',
        label: 'République centrafricaine',
      },
      {
        value: 'fr_GP',
        label: 'Guadeloupe',
      },
      {
        value: 'fr_RE',
        label: 'La Réunion',
      },
      {
        value: 'fr_CG',
        label: 'Congo-Brazzaville',
      },
      {
        value: 'fr_YT',
        label: 'Mayotte',
      },
      {
        value: 'fr_MA',
        label: 'Maroc',
      },
      {
        value: 'fr_GN',
        label: 'Guinée',
      },
      {
        value: 'fr_BI',
        label: 'Burundi',
      },
      {
        value: 'fr_HT',
        label: 'Haïti',
      },
      {
        value: 'fr_NC',
        label: 'Nouvelle-Calédonie',
      },
      {
        value: 'fr_DZ',
        label: 'Algérie',
      },
      {
        value: 'fr_KM',
        label: 'Comores',
      },
      {
        value: 'fr_MR',
        label: 'Mauritanie',
      },
      {
        value: 'fr_RW',
        label: 'Rwanda',
      },
      {
        value: 'fr_BJ',
        label: 'Bénin',
      },
      {
        value: 'fr_FR',
        label: 'France',
      },
      {
        value: 'fr_MF',
        label: 'Saint-Martin',
      },
      {
        value: 'fr_BL',
        label: 'Saint-Barthélemy',
      },
      {
        value: 'fr_GA',
        label: 'Gabon',
      },
      {
        value: 'fr_GQ',
        label: 'Guinée équatoriale',
      },
      {
        value: 'fr_MQ',
        label: 'Martinique',
      },
      {
        value: 'fr_CH',
        label: 'Suisse',
      },
      {
        value: 'fr_CA',
        label: 'Canada',
      },
      {
        value: 'fr_DJ',
        label: 'Djibouti',
      },
      {
        value: 'fr_MU',
        label: 'Maurice',
      },
      {
        value: 'fr_NE',
        label: 'Niger',
      },
      {
        value: 'fr_GF',
        label: 'Guyane française',
      },
      {
        value: 'fr_VU',
        label: 'Vanuatu',
      },
      {
        value: 'fr_LU',
        label: 'Luxembourg',
      },
    ],
  },
  {
    value: 'ksb',
    label: 'Kishambaa',
    children: [
      {
        value: 'ksb_TZ',
        label: 'Tanzania',
      },
    ],
  },
  {
    value: 'af',
    label: 'Afrikaans',
    children: [
      {
        value: 'af_ZA',
        label: 'Suid-Afrika',
      },
      {
        value: 'af_NA',
        label: 'Namibië',
      },
    ],
  },
  {
    value: 'lb',
    label: 'Lëtzebuergesch',
    children: [
      {
        value: 'lb_LU',
        label: 'Lëtzebuerg',
      },
    ],
  },
  {
    value: 'or',
    label: 'ଓଡ଼ିଆ',
    children: [
      {
        value: 'or_IN',
        label: 'ଭାରତ',
      },
    ],
  },
  {
    value: 'kkj',
    label: 'Kakɔ',
    children: [
      {
        value: 'kkj_CM',
        label: 'Kamɛrun',
      },
    ],
  },
  {
    value: 'hr',
    label: 'Hrvatski',
    children: [
      {
        value: 'hr_HR',
        label: 'Hrvatska',
      },
      {
        value: 'hr_BA',
        label: 'Bosna i Hercegovina',
      },
    ],
  },
  {
    value: 'bas',
    label: 'Ɓàsàa',
    children: [
      {
        value: 'bas_CM',
        label: 'Kàmɛ̀rûn',
      },
    ],
  },
  {
    value: 'hi',
    label: 'हिन्दी',
    children: [
      {
        value: 'hi_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'dz',
    label: 'རྫོང་ཁ',
    children: [
      {
        value: 'dz_BT',
        label: 'འབྲུག',
      },
    ],
  },
  {
    value: 'ru',
    label: 'Русский',
    children: [
      {
        value: 'ru_KG',
        label: 'Киргизия',
      },
      {
        value: 'ru_KZ',
        label: 'Казахстан',
      },
      {
        value: 'ru_UA',
        label: 'Украина',
      },
      {
        value: 'ru_MD',
        label: 'Молдова',
      },
      {
        value: 'ru_RU',
        label: 'Россия',
      },
      {
        value: 'ru_BY',
        label: 'Беларусь',
      },
    ],
  },
  {
    value: 'ro',
    label: 'Română',
    children: [
      {
        value: 'ro_RO',
        label: 'România',
      },
      {
        value: 'ro_MD',
        label: 'Republica Moldova',
      },
    ],
  },
  {
    value: 'da',
    label: 'Dansk',
    children: [
      {
        value: 'da_GL',
        label: 'Grønland',
      },
      {
        value: 'da_DK',
        label: 'Danmark',
      },
    ],
  },
  {
    value: 'mai',
    label: 'मैथिली',
    children: [
      {
        value: 'mai_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'nd',
    label: 'IsiNdebele',
    children: [
      {
        value: 'nd_ZW',
        label: 'Zimbabwe',
      },
    ],
  },
  {
    value: 'hu',
    label: 'Magyar',
    children: [
      {
        value: 'hu_HU',
        label: 'Magyarország',
      },
    ],
  },
  {
    value: 'te',
    label: 'తెలుగు',
    children: [
      {
        value: 'te_IN',
        label: 'భారత దేశం',
      },
    ],
  },
  {
    value: 'ml',
    label: 'മലയാളം',
    children: [
      {
        value: 'ml_IN',
        label: 'ഇന്ത്യ',
      },
    ],
  },
  {
    value: 'luo',
    label: 'Dholuo',
    children: [
      {
        value: 'luo_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'pt',
    label: 'Português',
    children: [
      {
        value: 'pt_TL',
        label: 'Timor-Leste',
      },
      {
        value: 'pt_AO',
        label: 'Angola',
      },
      {
        value: 'pt_PT',
        label: 'Portugal',
      },
      {
        value: 'pt_MZ',
        label: 'Moçambique',
      },
      {
        value: 'pt_GW',
        label: 'Guiné-Bissau',
      },
      {
        value: 'pt_CV',
        label: 'Cabo Verde',
      },
      {
        value: 'pt_MO',
        label: 'Macau',
      },
      {
        value: 'pt_ST',
        label: 'São Tomé e Príncipe',
      },
      {
        value: 'pt_BR',
        label: 'Brasil',
      },
    ],
  },
  {
    value: 'nl',
    label: 'Nederlands',
    children: [
      {
        value: 'nl_BQ',
        label: 'Caribisch Nederland',
      },
      {
        value: 'nl_NL',
        label: 'Nederland',
      },
      {
        value: 'nl_SX',
        label: 'Sint-Maarten',
      },
      {
        value: 'nl_SR',
        label: 'Surilabel',
      },
      {
        value: 'nl_CW',
        label: 'Curaçao',
      },
      {
        value: 'nl_AW',
        label: 'Aruba',
      },
      {
        value: 'nl_BE',
        label: 'België',
      },
    ],
  },
  {
    value: 'bn',
    label: 'বাংলা',
    children: [
      {
        value: 'bn_BD',
        label: 'বাংলাদেশ',
      },
      {
        value: 'bn_IN',
        label: 'ভারত',
      },
    ],
  },
  {
    value: 'mt',
    label: 'Malti',
    children: [
      {
        value: 'mt_MT',
        label: 'Malta',
      },
    ],
  },
  {
    value: 'rwk',
    label: 'Kiruwa',
    children: [
      {
        value: 'rwk_TZ',
        label: 'Tanzania',
      },
    ],
  },
  {
    value: 'ka',
    label: 'ქართული',
    children: [
      {
        value: 'ka_GE',
        label: 'საქართველო',
      },
    ],
  },
  {
    value: 'sdi',
    label: 'सिंधी',
    children: [
      {
        value: 'sdi_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'si',
    label: 'සිංහල',
    children: [
      {
        value: 'si_LK',
        label: 'ශ්‍රී ලංකාව',
      },
    ],
  },
  {
    value: 'nb',
    label: 'Norsk bokmål',
    children: [
      {
        value: 'nb_SJ',
        label: 'Svalbard og Jan Mayen',
      },
      {
        value: 'nb_NO',
        label: 'Norge',
      },
    ],
  },
  {
    value: 'dua',
    label: 'Duálá',
    children: [
      {
        value: 'dua_CM',
        label: 'Cameroun',
      },
    ],
  },
  {
    value: 'ak',
    label: 'Akan',
    children: [
      {
        value: 'ak_GH',
        label: 'Gaana',
      },
    ],
  },
  {
    value: 'id',
    label: 'Indonesia',
    children: [
      {
        value: 'id_ID',
        label: 'Indonesia',
      },
    ],
  },
  {
    value: 'bs_Cyrl',
    label: 'Босански (Ћирилица)',
    children: [
      {
        value: 'bs_Cyrl_BA',
        label: 'Босна и Херцеговина',
      },
    ],
  },
  {
    value: 'dyo',
    label: 'Joola',
    children: [
      {
        value: 'dyo_SN',
        label: 'Senegal',
      },
    ],
  },
  {
    value: 'teo',
    label: 'Kiteso',
    children: [
      {
        value: 'teo_KE',
        label: 'Kenia',
      },
      {
        value: 'teo_UG',
        label: 'Uganda',
      },
    ],
  },
  {
    value: 'vi',
    label: 'Tiếng Việt',
    children: [
      {
        value: 'vi_VN',
        label: 'Việt Nam',
      },
    ],
  },
  {
    value: 'br',
    label: 'Brezhoneg',
    children: [
      {
        value: 'br_FR',
        label: 'Frañs',
      },
    ],
  },
  {
    value: 'nmg',
    label: 'Nmg',
    children: [
      {
        value: 'nmg_CM',
        label: 'Kamerun',
      },
    ],
  },
  {
    value: 'ga',
    label: 'Gaeilge',
    children: [
      {
        value: 'ga_IE',
        label: 'Éire',
      },
    ],
  },
  {
    value: 'gv',
    label: 'Gaelg',
    children: [
      {
        value: 'gv_IM',
        label: 'Ellan Vannin',
      },
    ],
  },
  {
    value: 'kam',
    label: 'Kikamba',
    children: [
      {
        value: 'kam_KE',
        label: 'Kenya',
      },
    ],
  },
  {
    value: 'seh',
    label: 'Sena',
    children: [
      {
        value: 'seh_MZ',
        label: 'Moçambique',
      },
    ],
  },
  {
    value: 'hsb',
    label: 'Hornjoserbšćina',
    children: [
      {
        value: 'hsb_DE',
        label: 'Němska',
      },
    ],
  },
  {
    value: 'it',
    label: 'Italiano',
    children: [
      {
        value: 'it_SM',
        label: 'San Marino',
      },
      {
        value: 'it_CH',
        label: 'Svizzera',
      },
      {
        value: 'it_IT',
        label: 'Italia',
      },
    ],
  },
  {
    value: 'naq',
    label: 'Khoekhoegowab',
    children: [
      {
        value: 'naq_NA',
        label: 'Namibiab',
      },
    ],
  },
  {
    value: 'brx',
    label: 'बड़ो',
    children: [
      {
        value: 'brx_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'mgh',
    label: 'Makua',
    children: [
      {
        value: 'mgh_MZ',
        label: 'Umozambiki',
      },
    ],
  },
  {
    value: 'et',
    label: 'Eesti',
    children: [
      {
        value: 'et_EE',
        label: 'Eesti',
      },
    ],
  },
  {
    value: 'mk',
    label: 'Македонски',
    children: [
      {
        value: 'mk_MK',
        label: 'Македонија',
      },
    ],
  },
  {
    value: 'th',
    label: 'ไทย',
    children: [
      {
        value: 'th_TH',
        label: 'ไทย',
      },
    ],
  },
  {
    value: 'sa',
    label: 'संस्कृत',
    children: [
      {
        value: 'sa_IN',
        label: 'भारत',
      },
    ],
  },
  {
    value: 'uz_Cyrl',
    label: 'Ўзбек (Кирил)',
    children: [
      {
        value: 'uz_Cyrl_UZ',
        label: 'Ўзбекистон',
      },
    ],
  },
  {
    value: 'lg',
    label: 'Luganda',
    children: [
      {
        value: 'lg_UG',
        label: 'Yuganda',
      },
    ],
  },
  {
    value: 'km',
    label: 'ខ្មែរ',
    children: [
      {
        value: 'km_KH',
        label: 'កម្ពុជា',
      },
    ],
  },
  {
    value: 'en',
    label: 'English',
    children: [
      {
        value: 'en_TZ',
        label: 'Tanzania',
      },
      {
        value: 'en_AU',
        label: 'Australia',
      },
      {
        value: 'en_SD',
        label: 'Sudan',
      },
      {
        value: 'en_SC',
        label: 'Seychelles',
      },
      {
        value: 'en_BE',
        label: 'Belgium',
      },
      {
        value: 'en_TT',
        label: 'Trinidad & Tobago',
      },
      {
        value: 'en_MO',
        label: 'Macau',
      },
      {
        value: 'en_AS',
        label: 'American Samoa',
      },
      {
        value: 'en_VG',
        label: 'British Virgin Islands',
      },
      {
        value: 'en_KE',
        label: 'Kenya',
      },
      {
        value: 'en_AI',
        label: 'Anguilla',
      },
      {
        value: 'en_PK',
        label: 'Pakistan',
      },
      {
        value: 'en_TV',
        label: 'Tuvalu',
      },
      {
        value: 'en_IM',
        label: 'Isle of Man',
      },
      {
        value: 'en_HK',
        label: 'Hong Kong',
      },
      {
        value: 'en_DG',
        label: 'Diego Garcia',
      },
      {
        value: 'en_CY',
        label: 'Cyprus',
      },
      {
        value: 'en_NR',
        label: 'Nauru',
      },
      {
        value: 'en_SI',
        label: 'Slovenia',
      },
      {
        value: 'en_IE',
        label: 'Ireland',
      },
      {
        value: 'en_BZ',
        label: 'Belize',
      },
      {
        value: 'en_RW',
        label: 'Rwanda',
      },
      {
        value: 'en_TO',
        label: 'Tonga',
      },
      {
        value: 'en_MG',
        label: 'Madagascar',
      },
      {
        value: 'en_MH',
        label: 'Marshall Islands',
      },
      {
        value: 'en_SL',
        label: 'Sierra Leone',
      },
      {
        value: 'en_IO',
        label: 'British Indian Ocean Territory',
      },
      {
        value: 'en_FM',
        label: 'Micronesia',
      },
      {
        value: 'en_ZA',
        label: 'South Africa',
      },
      {
        value: 'en_DK',
        label: 'Denmark',
      },
      {
        value: 'en_CA',
        label: 'Canada',
      },
      {
        value: 'en_DE',
        label: 'Germany',
      },
      {
        value: 'en_GD',
        label: 'Grenada',
      },
      {
        value: 'en_UG',
        label: 'Uganda',
      },
      {
        value: 'en_MT',
        label: 'Malta',
      },
      {
        value: 'en_GG',
        label: 'Guernsey',
      },
      {
        value: 'en_ZW',
        label: 'Zimbabwe',
      },
      {
        value: 'en_PN',
        label: 'Pitcairn Islands',
      },
      {
        value: 'en_UM',
        label: 'U.S. Outlying Islands',
      },
      {
        value: 'en_BI',
        label: 'Burundi',
      },
      {
        value: 'en_AT',
        label: 'Austria',
      },
      {
        value: 'en_SS',
        label: 'South Sudan',
      },
      {
        value: 'en_BM',
        label: 'Bermuda',
      },
      {
        value: 'en_PR',
        label: 'Puerto Rico',
      },
      {
        value: 'en_TC',
        label: 'Turks & Caicos Islands',
      },
      {
        value: 'en_VC',
        label: 'St. Vincent & Grenadines',
      },
      {
        value: 'en_PW',
        label: 'Palau',
      },
      {
        value: 'en_SX',
        label: 'Sint Maarten',
      },
      {
        value: 'en_WS',
        label: 'Samoa',
      },
      {
        value: 'en_MU',
        label: 'Mauritius',
      },
      {
        value: 'en_MP',
        label: 'Northern Mariana Islands',
      },
      {
        value: 'en_BB',
        label: 'Barbados',
      },
      {
        value: 'en_CC',
        label: 'Cocos (Keeling) Islands',
      },
      {
        value: 'en_VU',
        label: 'Vanuatu',
      },
      {
        value: 'en_JM',
        label: 'Jamaica',
      },
      {
        value: 'en_GY',
        label: 'Guyana',
      },
      {
        value: 'en_MW',
        label: 'Malawi',
      },
      {
        value: 'en_KY',
        label: 'Cayman Islands',
      },
      {
        value: 'en_SE',
        label: 'Sweden',
      },
      {
        value: 'en_BS',
        label: 'Bahamas',
      },
      {
        value: 'en_SH',
        label: 'St. Helena',
      },
      {
        value: 'en_DM',
        label: 'Dominica',
      },
      {
        value: 'en_US',
        label: 'United States',
      },
      {
        value: 'en_GI',
        label: 'Gibraltar',
      },
      {
        value: 'en_NL',
        label: 'Netherlands',
      },
      {
        value: 'en_GH',
        label: 'Ghana',
      },
      {
        value: 'en_FI',
        label: 'Finland',
      },
      {
        value: 'en_CM',
        label: 'Cameroon',
      },
      {
        value: 'en_LC',
        label: 'St. Lucia',
      },
      {
        value: 'en_GM',
        label: 'Gambia',
      },
      {
        value: 'en_VI',
        label: 'U.S. Virgin Islands',
      },
      {
        value: 'en_PG',
        label: 'Papua New Guinea',
      },
      {
        value: 'en_CX',
        label: 'Christmas Island',
      },
      {
        value: 'en_NG',
        label: 'Nigeria',
      },
      {
        value: 'en_LS',
        label: 'Lesotho',
      },
      {
        value: 'en_IL',
        label: 'Israel',
      },
      {
        value: 'en_NF',
        label: 'Norfolk Island',
      },
      {
        value: 'en_TK',
        label: 'Tokelau',
      },
      {
        value: 'en_MS',
        label: 'Montserrat',
      },
      {
        value: 'en_FK',
        label: 'Falkland Islands (Islas Malvinas)',
      },
      {
        value: 'en_KN',
        label: 'St. Kitts & Nevis',
      },
      {
        value: 'en_GB',
        label: 'United Kingdom',
      },
      {
        value: 'en_ER',
        label: 'Eritrea',
      },
      {
        value: 'en_AG',
        label: 'Antigua & Barbuda',
      },
      {
        value: 'en_PH',
        label: 'Philippines',
      },
      {
        value: 'en_IN',
        label: 'India',
      },
      {
        value: 'en_NU',
        label: 'Niue',
      },
      {
        value: 'en_FJ',
        label: 'Fiji',
      },
      {
        value: 'en_SZ',
        label: 'Swaziland',
      },
      {
        value: 'en_LR',
        label: 'Liberia',
      },
      {
        value: 'en_JE',
        label: 'Jersey',
      },
      {
        value: 'en_NZ',
        label: 'New Zealand',
      },
      {
        value: 'en_ZM',
        label: 'Zambia',
      },
      {
        value: 'en_GU',
        label: 'Guam',
      },
      {
        value: 'en_SG',
        label: 'Singapore',
      },
      {
        value: 'en_NA',
        label: 'Namibia',
      },
      {
        value: 'en_CK',
        label: 'Cook Islands',
      },
      {
        value: 'en_BW',
        label: 'Botswana',
      },
      {
        value: 'en_SB',
        label: 'Solomon Islands',
      },
      {
        value: 'en_CH',
        label: 'Switzerland',
      },
      {
        value: 'en_MY',
        label: 'Malaysia',
      },
      {
        value: 'en_KI',
        label: 'Kiribati',
      },
    ],
  },
  {
    value: 'he',
    label: 'עברית',
    children: [
      {
        value: 'he_IL',
        label: 'ישראל',
      },
    ],
  },
  {
    value: 'uz_Latn',
    label: 'O‘zbek (lotin)',
    children: [
      {
        value: 'uz_Latn_UZ',
        label: 'Oʻzbekiston',
      },
    ],
  },
  {
    value: 'kab',
    label: 'Taqbaylit',
    children: [
      {
        value: 'kab_DZ',
        label: 'Lezzayer',
      },
    ],
  },
  {
    value: 'mas',
    label: 'Maa',
    children: [
      {
        value: 'mas_KE',
        label: 'Kenya',
      },
      {
        value: 'mas_TZ',
        label: 'Tansania',
      },
    ],
  },
  {
    value: 'agq',
    label: 'Aghem',
    children: [
      {
        value: 'agq_CM',
        label: 'Kàmàlûŋ',
      },
    ],
  },
  {
    value: 'lt',
    label: 'Lietuvių',
    children: [
      {
        value: 'lt_LT',
        label: 'Lietuva',
      },
    ],
  },
  {
    value: 'de',
    label: 'Deutsch',
    children: [
      {
        value: 'de_LI',
        label: 'Liechtenstein',
      },
      {
        value: 'de_DE',
        label: 'Deutschland',
      },
      {
        value: 'de_BE',
        label: 'Belgien',
      },
      {
        value: 'de_CH',
        label: 'Schweiz',
      },
      {
        value: 'de_AT',
        label: 'Österreich',
      },
      {
        value: 'de_LU',
        label: 'Luxemburg',
      },
    ],
  },
  {
    value: 'bm',
    label: 'Bamanakan',
    children: [
      {
        value: 'bm_ML',
        label: 'Mali',
      },
    ],
  },
  {
    value: 'as',
    label: 'অসমীয়া',
    children: [
      {
        value: 'as_IN',
        label: 'ভাৰত',
      },
    ],
  },
  {
    value: 'cs',
    label: 'Čeština',
    children: [
      {
        value: 'cs_CZ',
        label: 'Česká republika',
      },
    ],
  },
  {
    value: 'bs_Latn',
    label: 'Bosanski (latinica)',
    children: [
      {
        value: 'bs_Latn_BA',
        label: 'Bosna i Hercegovina',
      },
    ],
  },
  {
    value: 'lag',
    label: 'Kɨlaangi',
    children: [
      {
        value: 'lag_TZ',
        label: 'Taansanía',
      },
    ],
  },
  {
    value: 'ps',
    label: 'پښتو',
    children: [
      {
        value: 'ps_AF',
        label: 'افغانستان',
      },
    ],
  },
  {
    value: 'nyn',
    label: 'Runyankore',
    children: [
      {
        value: 'nyn_UG',
        label: 'Uganda',
      },
    ],
  },
];
